import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 30rem 1fr;
  min-height: 100%;
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  &:not(:last-child) {
    border-right: 1px solid ${colors.gray2};
  }
`;

export const ProgressSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  max-height: calc(100vh - 25rem);
  overflow-y: auto;
`;

export const ProgressSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.medium};
  padding: ${sizes.medium};
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.medium};
  padding: 3rem 3rem 0 3rem;
  min-width: 0;
`;

export const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
`;

export const ProgressText = styled(StandardTypography)`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;

export const Progress = styled.progress`
  display: flex;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: ${sizes.xxSmall};
  border: none;
  border-radius: ${sizes.xxSmall};
  background: ${colors.teal2};

  &::-webkit-progress-bar {
    background: transparent;
  }

  &::-webkit-progress-value {
    border-radius: ${sizes.xxSmall};
    background: ${colors.teal5};
  }

  &::-moz-progress-bar {
    background: ${colors.teal5};
  }
`;

export const StepLabel = styled.span`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;

export const AppointmentLabel = styled.span`
  font-size: ${fontSize.heading};
  font-weight: 600;
  color: ${colors.primary1};  
`;
